var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path10, _g8, _g9, _g10, _g11, _g12, _g13, _path11, _g14, _g15, _g16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 17.84H0.796875V5.47914C0.796875 5.11489 0.962468 4.76555 1.25722 4.50798C1.55198 4.25041 1.95176 4.10571 2.36861 4.10571H11.102C12.2022 4.10571 13.0974 4.88797 13.0974 5.84937V17.84Z",
    fill: "#99919F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 17.84H0.796875V5.47914C0.796875 5.11489 0.962468 4.76555 1.25722 4.50798C1.55198 4.25041 1.95176 4.10571 2.36861 4.10571H11.102C12.2022 4.10571 13.0974 4.88797 13.0974 5.84937V17.84Z",
    fill: "url(#paint0_linear_2228_136930)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 17.84H0.796875V5.47914C0.796875 5.11489 0.962468 4.76555 1.25722 4.50798C1.55198 4.25041 1.95176 4.10571 2.36861 4.10571H11.102C12.2022 4.10571 13.0974 4.88797 13.0974 5.84937V17.84Z",
    fill: "url(#paint1_linear_2228_136930)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 17.84H0.796875V5.47914C0.796875 5.11489 0.962468 4.76555 1.25722 4.50798C1.55198 4.25041 1.95176 4.10571 2.36861 4.10571H11.102C12.2022 4.10571 13.0974 4.88797 13.0974 5.84937V17.84Z",
    fill: "url(#paint2_linear_2228_136930)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 17.84H7.63281V5.47914C7.63281 5.11489 7.79841 4.76555 8.09316 4.50798C8.38792 4.25041 8.78769 4.10571 9.20454 4.10571H18.3616C18.7784 4.10571 19.1782 4.25041 19.473 4.50798C19.7677 4.76555 19.9333 5.11489 19.9333 5.47914V17.84Z",
    fill: "#B5AEBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 17.84H7.63281V5.47914C7.63281 5.11489 7.79841 4.76555 8.09316 4.50798C8.38792 4.25041 8.78769 4.10571 9.20454 4.10571H18.3616C18.7784 4.10571 19.1782 4.25041 19.473 4.50798C19.7677 4.76555 19.9333 5.11489 19.9333 5.47914V17.84Z",
    fill: "url(#paint3_linear_2228_136930)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 17.84H7.63281V5.47914C7.63281 5.11489 7.79841 4.76555 8.09316 4.50798C8.38792 4.25041 8.78769 4.10571 9.20454 4.10571H18.3616C18.7784 4.10571 19.1782 4.25041 19.473 4.50798C19.7677 4.76555 19.9333 5.11489 19.9333 5.47914V17.84Z",
    fill: "url(#paint4_linear_2228_136930)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 17.84H7.63281V5.47914C7.63281 5.11489 7.79841 4.76555 8.09316 4.50798C8.38792 4.25041 8.78769 4.10571 9.20454 4.10571H18.3616C18.7784 4.10571 19.1782 4.25041 19.473 4.50798C19.7677 4.76555 19.9333 5.11489 19.9333 5.47914V17.84Z",
    fill: "url(#paint5_linear_2228_136930)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 17.84H7.63281V5.47914C7.63281 5.11489 7.79841 4.76555 8.09316 4.50798C8.38792 4.25041 8.78769 4.10571 9.20454 4.10571H18.3616C18.7784 4.10571 19.1782 4.25041 19.473 4.50798C19.7677 4.76555 19.9333 5.11489 19.9333 5.47914V17.84Z",
    fill: "url(#paint6_radial_2228_136930)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 6.50684H16.1932C16.0045 6.50684 15.8516 6.64051 15.8516 6.80541V7.99492C15.8516 8.15981 16.0045 8.29349 16.1932 8.29349H18.2324C18.4211 8.29349 18.5741 8.15981 18.5741 7.99492V6.80541C18.5741 6.64051 18.4211 6.50684 18.2324 6.50684Z",
    fill: "url(#paint7_linear_2228_136930)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53317 6.50684H2.49402C2.30532 6.50684 2.15234 6.64051 2.15234 6.80541V7.99492C2.15234 8.15981 2.30532 8.29349 2.49402 8.29349H4.53317C4.72188 8.29349 4.87486 8.15981 4.87486 7.99492V6.80541C4.87486 6.64051 4.72188 6.50684 4.53317 6.50684Z",
    fill: "url(#paint8_linear_2228_136930)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 9.45923H16.1932C16.0045 9.45923 15.8516 9.5929 15.8516 9.7578V10.9473C15.8516 11.1122 16.0045 11.2459 16.1932 11.2459H18.2324C18.4211 11.2459 18.5741 11.1122 18.5741 10.9473V9.7578C18.5741 9.5929 18.4211 9.45923 18.2324 9.45923Z",
    fill: "url(#paint9_linear_2228_136930)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53317 9.45923H2.49402C2.30532 9.45923 2.15234 9.5929 2.15234 9.7578V10.9473C2.15234 11.1122 2.30532 11.2459 2.49402 11.2459H4.53317C4.72188 11.2459 4.87486 11.1122 4.87486 10.9473V9.7578C4.87486 9.5929 4.72188 9.45923 4.53317 9.45923Z",
    fill: "url(#paint10_linear_2228_136930)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2324 12.4172H16.1932C16.0045 12.4172 15.8516 12.5509 15.8516 12.7158V13.9053C15.8516 14.0702 16.0045 14.2039 16.1932 14.2039H18.2324C18.4211 14.2039 18.5741 14.0702 18.5741 13.9053V12.7158C18.5741 12.5509 18.4211 12.4172 18.2324 12.4172Z",
    fill: "url(#paint11_linear_2228_136930)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53317 12.4172H2.49402C2.30532 12.4172 2.15234 12.5509 2.15234 12.7158V13.9053C2.15234 14.0702 2.30532 14.2039 2.49402 14.2039H4.53317C4.72188 14.2039 4.87486 14.0702 4.87486 13.9053V12.7158C4.87486 12.5509 4.72188 12.4172 4.53317 12.4172Z",
    fill: "url(#paint12_linear_2228_136930)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1985 17.8401H3.53125V2.58909C3.53125 1.77697 4.28295 1.12012 5.21232 1.12012H15.5174C16.4468 1.12012 17.1985 1.77697 17.1985 2.58909V17.8401Z",
    fill: "url(#paint13_linear_2228_136930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1985 17.8401H3.53125V2.58909C3.53125 1.77697 4.28295 1.12012 5.21232 1.12012H15.5174C16.4468 1.12012 17.1985 1.77697 17.1985 2.58909V17.8401Z",
    fill: "url(#paint14_linear_2228_136930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1985 17.8401H3.53125V2.58909C3.53125 1.77697 4.28295 1.12012 5.21232 1.12012H15.5174C16.4468 1.12012 17.1985 1.77697 17.1985 2.58909V17.8401Z",
    fill: "url(#paint15_linear_2228_136930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1985 17.8401H3.53125V2.58909C3.53125 1.77697 4.28295 1.12012 5.21232 1.12012H15.5174C16.4468 1.12012 17.1985 1.77697 17.1985 2.58909V17.8401Z",
    fill: "url(#paint16_radial_2228_136930)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1985 17.8401H3.53125V2.58909C3.53125 1.77697 4.28295 1.12012 5.21232 1.12012H15.5174C16.4468 1.12012 17.1985 1.77697 17.1985 2.58909V17.8401Z",
    fill: "url(#paint17_radial_2228_136930)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4127 17.8402H8.3125V15.6009C8.3125 15.1889 8.69518 14.8545 9.1667 14.8545H11.5585C12.03 14.8545 12.4195 15.1889 12.4195 15.6069V17.8402H12.4127Z",
    fill: "url(#paint18_linear_2228_136930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4127 17.8402H8.3125V15.6009C8.3125 15.1889 8.69518 14.8545 9.1667 14.8545H11.5585C12.03 14.8545 12.4195 15.1889 12.4195 15.6069V17.8402H12.4127Z",
    fill: "url(#paint19_linear_2228_136930)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32614 2.93359H7.28699C7.09829 2.93359 6.94531 3.06727 6.94531 3.23217V4.42167C6.94531 4.58657 7.09829 4.72025 7.28699 4.72025H9.32614C9.51485 4.72025 9.66782 4.58657 9.66782 4.42167V3.23217C9.66782 3.06727 9.51485 2.93359 9.32614 2.93359Z",
    fill: "url(#paint20_linear_2228_136930)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32614 5.88916H7.28699C7.09829 5.88916 6.94531 6.02284 6.94531 6.18773V7.37724C6.94531 7.54214 7.09829 7.67581 7.28699 7.67581H9.32614C9.51485 7.67581 9.66782 7.54214 9.66782 7.37724V6.18773C9.66782 6.02284 9.51485 5.88916 9.32614 5.88916Z",
    fill: "url(#paint21_linear_2228_136930)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32614 8.84424H7.28699C7.09829 8.84424 6.94531 8.97791 6.94531 9.14281V10.3323C6.94531 10.4972 7.09829 10.6309 7.28699 10.6309H9.32614C9.51485 10.6309 9.66782 10.4972 9.66782 10.3323V9.14281C9.66782 8.97791 9.51485 8.84424 9.32614 8.84424Z",
    fill: "url(#paint22_linear_2228_136930)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32614 11.8901H7.28699C7.09829 11.8901 6.94531 12.0238 6.94531 12.1887V13.3782C6.94531 13.5431 7.09829 13.6768 7.28699 13.6768H9.32614C9.51485 13.6768 9.66782 13.5431 9.66782 13.3782V12.1887C9.66782 12.0238 9.51485 11.8901 9.32614 11.8901Z",
    fill: "url(#paint23_linear_2228_136930)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 2.93359H11.3807C11.192 2.93359 11.0391 3.06727 11.0391 3.23217V4.42167C11.0391 4.58657 11.192 4.72025 11.3807 4.72025H13.4199C13.6086 4.72025 13.7616 4.58657 13.7616 4.42167V3.23217C13.7616 3.06727 13.6086 2.93359 13.4199 2.93359Z",
    fill: "url(#paint24_linear_2228_136930)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 5.88916H11.3807C11.192 5.88916 11.0391 6.02284 11.0391 6.18773V7.37724C11.0391 7.54214 11.192 7.67581 11.3807 7.67581H13.4199C13.6086 7.67581 13.7616 7.54214 13.7616 7.37724V6.18773C13.7616 6.02284 13.6086 5.88916 13.4199 5.88916Z",
    fill: "#FB4EFF",
    fillOpacity: 0.5
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 5.88916H11.3807C11.192 5.88916 11.0391 6.02284 11.0391 6.18773V7.37724C11.0391 7.54214 11.192 7.67581 11.3807 7.67581H13.4199C13.6086 7.67581 13.7616 7.54214 13.7616 7.37724V6.18773C13.7616 6.02284 13.6086 5.88916 13.4199 5.88916Z",
    fill: "url(#paint25_linear_2228_136930)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 8.84424H11.3807C11.192 8.84424 11.0391 8.97791 11.0391 9.14281V10.3323C11.0391 10.4972 11.192 10.6309 11.3807 10.6309H13.4199C13.6086 10.6309 13.7616 10.4972 13.7616 10.3323V9.14281C13.7616 8.97791 13.6086 8.84424 13.4199 8.84424Z",
    fill: "url(#paint26_linear_2228_136930)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dd_2228_136930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 11.8901H11.3807C11.192 11.8901 11.0391 12.0238 11.0391 12.1887V13.3782C11.0391 13.5431 11.192 13.6768 11.3807 13.6768H13.4199C13.6086 13.6768 13.7616 13.5431 13.7616 13.3782V12.1887C13.7616 12.0238 13.6086 11.8901 13.4199 11.8901Z",
    fill: "url(#paint27_linear_2228_136930)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2228_136930",
    x: 14.8016,
    y: 5.95684,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2228_136930",
    x: 1.10234,
    y: 5.95684,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2228_136930",
    x: 14.8016,
    y: 8.90923,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2228_136930",
    x: 1.10234,
    y: 8.90923,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2228_136930",
    x: 14.8016,
    y: 11.8672,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2228_136930",
    x: 1.10234,
    y: 11.8672,
    width: 4.32266,
    height: 3.38662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2228_136930",
    x: 3.53125,
    y: 0.220117,
    width: 16.668,
    height: 18.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2228_136930",
    x: 7.3125,
    y: 14.6545,
    width: 5.30547,
    height: 4.1856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.4,
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.101961 0 0 0 0 0.223529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_2228_136930",
    x: 5.89531,
    y: 2.18359,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_2228_136930",
    x: 5.89531,
    y: 5.13916,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dd_2228_136930",
    x: 5.89531,
    y: 8.09424,
    width: 4.52266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dd_2228_136930",
    x: 5.89531,
    y: 11.1401,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd_2228_136930",
    x: 9.98906,
    y: 2.18359,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dd_2228_136930",
    x: 9.98906,
    y: 5.13916,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_dd_2228_136930",
    x: 9.98906,
    y: 8.09424,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dd_2228_136930",
    x: 9.98906,
    y: 11.1401,
    width: 4.67266,
    height: 3.58662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2228_136930",
    result: "effect2_dropShadow_2228_136930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2228_136930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2228_136930",
    x1: 3.92052,
    y1: 13.1739,
    x2: 2.60847,
    y2: 13.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605965",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2228_136930",
    x1: 4.13715,
    y1: 3.76713,
    x2: 4.13715,
    y2: 5.68157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2228_136930",
    x1: 0.796875,
    y1: 13.7926,
    x2: 1.60256,
    y2: 13.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B777E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B777E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2228_136930",
    x1: 17.0885,
    y1: 14.4811,
    x2: 17.5368,
    y2: 14.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59FA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2228_136930",
    x1: 17.217,
    y1: 4.03107,
    x2: 17.217,
    y2: 4.81512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2228_136930",
    x1: 20.1636,
    y1: 13.66,
    x2: 18.7969,
    y2: 13.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2CFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CFD4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2228_136930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.801 4.29262) rotate(141.98) scale(1.54512 1.3805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#D7D6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2228_136930",
    x1: 16.062,
    y1: 7.40016,
    x2: 18.5741,
    y2: 7.40016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2228_136930",
    x1: 2.3635,
    y1: 7.40016,
    x2: 4.87486,
    y2: 7.40016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47ABE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2228_136930",
    x1: 16.062,
    y1: 10.3526,
    x2: 18.5741,
    y2: 10.3526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2228_136930",
    x1: 2.3635,
    y1: 10.3526,
    x2: 4.87486,
    y2: 10.3526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47ABE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2228_136930",
    x1: 16.062,
    y1: 13.3106,
    x2: 18.5741,
    y2: 13.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2228_136930",
    x1: 2.3635,
    y1: 13.3106,
    x2: 4.87486,
    y2: 13.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47ABE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2228_136930",
    x1: 4.74627,
    y1: 16.3198,
    x2: 15.1682,
    y2: 16.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEB3C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2228_136930",
    x1: 10.3649,
    y1: 0.970234,
    x2: 10.3649,
    y2: 2.55207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B7B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2228_136930",
    x1: 17.1985,
    y1: 10.5478,
    x2: 15.7067,
    y2: 10.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0DDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DDE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2228_136930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4676 1.11983) rotate(140.756) scale(2.43242 1.75826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E7E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2228_136930",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3649 17.8401) rotate(-90) scale(2.18308 6.05122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#AFA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFA5B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2228_136930",
    x1: 8.3125,
    y1: 16.3491,
    x2: 12.7468,
    y2: 16.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E405B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F324C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2228_136930",
    x1: 8.46967,
    y1: 17.8402,
    x2: 9.10998,
    y2: 17.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#574C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#574C64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2228_136930",
    x1: 7.15647,
    y1: 3.82692,
    x2: 9.66782,
    y2: 3.82692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2228_136930",
    x1: 7.15647,
    y1: 6.78249,
    x2: 9.66782,
    y2: 6.78249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2228_136930",
    x1: 7.15647,
    y1: 9.73756,
    x2: 9.66782,
    y2: 9.73756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2228_136930",
    x1: 7.15647,
    y1: 12.7835,
    x2: 9.66782,
    y2: 12.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2228_136930",
    x1: 11.2502,
    y1: 3.82692,
    x2: 13.7616,
    y2: 3.82692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2228_136930",
    x1: 11.2502,
    y1: 6.78249,
    x2: 13.7616,
    y2: 6.78249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2228_136930",
    x1: 11.2502,
    y1: 9.73756,
    x2: 13.7616,
    y2: 9.73756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2228_136930",
    x1: 11.2502,
    y1: 12.7835,
    x2: 13.7616,
    y2: 12.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.8e6f0c19028f5dc1e62da8bb1396eab5.svg";
export { ForwardRef as ReactComponent };